import React, { useEffect, useState } from 'react'
import Carousel from './Carousel'
import styles from './styles.module.css'
import { CircularProgress } from '@mui/material'
import { PALETTE } from '../../../styles/constants'

function DataPacksCarousel({ backgroundColor, textColor = { value: PALETTE.gray80 }, slideCtaText, carouselCta }) {
  // highlightedDataPacks was Overmind state read ONLY here and fetched client-side
  // post-mount (it has no SSR surface bundle), so it moved to LOCAL component state
  // (Phase C2 part 1) — mirrors operators.getHighlightedDataPacks: GET the packs,
  // fall back to [] on error.
  const [highlightedDataPacks, setHighlightedDataPacks] = useState([])

  useEffect(() => {
    let cancelled = false
    fetch('/api/getHighlightedDataPacks')
      .then((res) => res.json())
      .then((data) => { if (!cancelled) setHighlightedDataPacks(Array.isArray(data) ? data : []) })
      .catch((e) => {
        console.log('error', e.message)
        if (!cancelled) setHighlightedDataPacks([])
      })
    return () => { cancelled = true }
  }, [])

  // #418: gate the loader on THIS section's OWN data (highlightedDataPacks). It is
  // NOT SSR-hydrated, so it is genuinely absent (empty []) on BOTH the SSR render
  // and the client's first render — the guard is a pure function of that data, so
  // the placeholder is IDENTICAL on SSR and the client's first render (no hydration
  // mismatch), then the carousel populates once the post-mount fetch resolves.
  if (!highlightedDataPacks || !highlightedDataPacks.length) {
    return (
      <div className={styles.loading} style={{ backgroundColor: backgroundColor.value, color: textColor.value }}>
        <CircularProgress color="inherit"/>
      </div>
    )
  }

  return (
    <>
      <Carousel
        backgroundColor={backgroundColor}
        textColor={textColor}
        dataPacks={highlightedDataPacks}
        slideCtaText={slideCtaText}
        carouselCta={carouselCta}
      />
    </>
  )
}

export default DataPacksCarousel
